export enum ReportsTabs {
  ManagersOverview,
  ManagersRetail,
  Accounts
}

export interface ReportsState {
  activeTab: ReportsTabs;
}
